/**
 * Chargeback-specific constants
 *
 * Entry types and stakeholder types as returned by the chargeback backend.
 * These use UPPERCASE naming (different from the general accounting constants).
 */

// Entry types (backend returns UPPERCASE)
export const ENTRY_TYPES = {
    ORDER_REVENUE: 'ORDER_REVENUE',
    ORDER_FEE: 'ORDER_FEE',
    ORDER_COST: 'ORDER_COST',
    DISPUTE_FEE: 'DISPUTE_FEE',
}

export const ENTRY_TYPE_LABELS = {
    [ENTRY_TYPES.ORDER_REVENUE]: 'Revenue',
    [ENTRY_TYPES.ORDER_FEE]: 'Fee',
    [ENTRY_TYPES.ORDER_COST]: 'Cost',
    [ENTRY_TYPES.DISPUTE_FEE]: 'Dispute Fee',
}

// Stakeholder types (backend returns these values)
// TODO: Verificare nomenclatura 'photographer' — potrebbe essere 'contract_manager'
export const STAKEHOLDER_TYPES = {
    PHOTOGRAPHER: 'photographer',
    PICA: 'pica',
    ORGANIZER: 'organizer',
}

export const STAKEHOLDER_TYPE_LABELS = {
    [STAKEHOLDER_TYPES.PHOTOGRAPHER]: 'Photographer',
    [STAKEHOLDER_TYPES.PICA]: 'Pica',
    [STAKEHOLDER_TYPES.ORGANIZER]: 'Organizer',
}

export const STAKEHOLDER_TYPE_COLORS = {
    [STAKEHOLDER_TYPES.PHOTOGRAPHER]: 'info',
    [STAKEHOLDER_TYPES.PICA]: 'primary',
    [STAKEHOLDER_TYPES.ORGANIZER]: 'success',
}

/**
 * Normalize a chargeback entry for use with LedgerEntriesTable.
 * Maps UPPERCASE entry_type to lowercase (matching global accounting constants).
 */
export function normalizeEntry(entry) {
    return {
        ...entry,
        entry_type: entry.entry_type ? entry.entry_type.toLowerCase() : entry.entry_type,
    }
}
